import {
  createFeature,
  FEATURE_STATUS,
} from 'components/Providers/FeatureFlag/FeatureFlagProvider';

export const countriesWhereCreditAccountIsAvailable = ['GB'];
export const countriesWhereWalletIsAvailable = ['GB', 'FR'];
export const countriesWhereCreditAccountIsNotAvailable = ['US', 'CA', 'FR', 'DE', 'CH'];
export const countriesWithSmsOptOutModalDisabled = ['US', 'CA', 'DE', 'CH', 'FR', 'GB'];

// Refer to "Feature Provider, Context, and useFeatureFlag hook" section of README for more details on usage
export const featureFlagConfig = {
  monthlyStatements: createFeature({
    status: FEATURE_STATUS.All,
    rules: null,
  }),
  creditAccount: createFeature({
    status: FEATURE_STATUS.All,
    rules: {
      excludeCountries: countriesWhereCreditAccountIsNotAvailable,
    },
  }),
  selfRegistrationV2: createFeature({
    status: FEATURE_STATUS.All,
    rules: null,
  }),
  smsReminder: createFeature({
    status: FEATURE_STATUS.Development,
    rules: {
      excludeCountries: countriesWithSmsOptOutModalDisabled,
    },
  }),
  invoices: createFeature({
    status: FEATURE_STATUS.All,
    rules: null,
  }),
  wallet: createFeature({
    status: FEATURE_STATUS.Development,
    rules: {
      includeCountries: countriesWhereWalletIsAvailable,
    },
  }),
};

export default featureFlagConfig;
